import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {getWebComponentInstance} from "fg-frontend/src/webComponents/decorate";

const fragments = {
	FILE_BUTTON: '[data-fragment="UploadFileOverlay.fileButton"]',
}

class UploadFileOverlay extends WebComponent {

	constructor(props) {
		super(props);
		const {
		} = props;
		this.state = {
		};
	}

	didMount() {
		const {
		} = this.props;

		this.fileButtonElement = this.element.querySelector(fragments.FILE_BUTTON);
		this.on('change', fragments.FILE_BUTTON, this.handleClickOnFileButton);

		const universalPreloaderComponentElement = document.getElementById('universalPreloader');
		this.universalPreloaderComponent = getWebComponentInstance(universalPreloaderComponentElement);
	}

	handleClickOnFileButton = (e) => {
		this.universalPreloaderComponent.handleOn(10);

		// var data = new FormData();
		// console.log(this.fileButtonElement.files[0]);
		// data.append('file', this.fileButtonElement.files[0]);
		// console.log(data);
		// let request = new XMLHttpRequest();
		// request.open('get', '/order/step3?formId=' + this.getFormId() + '&csrf=' + this.getCsrfToken() + '&eventName.orderFileUpload:orderRecord=');
		// request.upload.addEventListener('progress', (e) => {
		// 	let percent = (e.loaded /e.total)*100;
		// 	console.log(percent);
		// });
		//
		// request.addEventListener('load', () => {
		// 	// console.log(request.status);
		// 	// console.log(request.response);
		// });

		// request.send(data);
	};

	handleOn = (id) => {
	};

	handleOff = (id) => {
	};

	getCsrfToken = () => {
		return document.querySelector('form[id^=wizardContent] input[name=csrf]').value;
	};

	getFormId = () => {
		return document.querySelector('form[id^=wizardContent] input[name=formId]').value;
	};

}

export default UploadFileOverlay;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/UploadFileOverlay.js